import { useGetOrderByIdBasicQuery, Instacart_Care_Tools_V1_ServiceUser } from '../../api'

export const useGetOrderByIdBasic = (orderId: string | null) => {
  const { data, loading } = useGetOrderByIdBasicQuery({
    variables: {
      orderId: orderId ?? '',
      serviceUser: Instacart_Care_Tools_V1_ServiceUser.ServiceUserIppCxAdmin,
    },
    fetchPolicy: 'cache-and-network',
    skip: !orderId,
  })

  const order = data?.instacart_care_tools_v1_CareToolsService_GetOrderByIdBasic?.order ?? null

  return { data: order, loading }
}
